import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const Overline = ({ children, className = "" }) => (
  <p className={`text-xs tracking-[0.25em] uppercase font-bold text-ember ${className}`}>{children}</p>
);

export const SectionHead = ({ overline, title, sub, className = "" }) => (
  <div className={`mb-14 ${className}`}>
    <Overline className="mb-4">{overline}</Overline>
    <h2 className="font-heading text-3xl sm:text-4xl uppercase tracking-tight text-white max-w-3xl leading-[1.05]">{title}</h2>
    {sub && <p className="text-silver mt-5 max-w-2xl text-base leading-relaxed">{sub}</p>}
  </div>
);

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.65, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const CountUp = ({ end, suffix = "", decimals = 0, duration = 1800 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(end * eased);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, end, duration]);

  return <span ref={ref}>{val.toFixed(decimals)}{suffix}</span>;
};

export const StatusBadge = ({ status }) => {
  const map = {
    Completed: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
    Ongoing: "bg-ember/10 text-ember border-ember/30",
  };
  return (
    <span className={`inline-block text-[11px] uppercase tracking-[0.15em] font-bold px-3 py-1 border ${map[status] || "bg-white/5 text-silver border-line"}`}>
      {status}
    </span>
  );
};
